"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.button = void 0;
const ButtonTypes_1 = require("../../components/atoms/Button/ButtonTypes");
const colors_1 = require("./colors");
exports.button = {
    type: {
        [ButtonTypes_1.ButtonAction.PRIMARY]: {
            color: colors_1.colors.white,
            borderColor: colors_1.colors.transparent,
            backgroundColor: colors_1.colors.primary[500],
            fontFamily: 'Roboto-Regular',
            border: 'none',
            inverted: {
                color: colors_1.colors.primary[500],
                backgroundColor: colors_1.colors.white,
                borderColor: colors_1.colors.transparent,
            },
            disabled: {
                color: colors_1.colors.white,
                backgroundColor: colors_1.colors.primary[200],
                borderColor: colors_1.colors.transparent,
            },
            horizontalPadding: true,
        },
        [ButtonTypes_1.ButtonAction.SECONDARY]: {
            backgroundColor: colors_1.colors.white,
            borderColor: colors_1.colors.primary[500],
            color: colors_1.colors.text,
            fontFamily: 'Roboto-Regular',
            border: '1px solid',
            inverted: {
                backgroundColor: colors_1.colors.transparent,
                color: colors_1.colors.white,
                borderColor: colors_1.colors.white,
            },
            disabled: {
                borderColor: colors_1.colors.primary[200],
                backgroundColor: colors_1.colors.white,
                color: colors_1.colors.dark[100],
            },
            horizontalPadding: true,
        },
        [ButtonTypes_1.ButtonAction.TERTIARY]: {
            backgroundColor: colors_1.colors.transparent,
            color: colors_1.colors.link,
            borderColor: colors_1.colors.transparent,
            inverted: {
                backgroundColor: colors_1.colors.transparent,
                color: colors_1.colors.link,
                borderColor: colors_1.colors.transparent,
            },
            fontFamily: 'Roboto-Regular',
            border: 'none',
            disabled: {
                color: colors_1.colors.primary[200],
                backgroundColor: colors_1.colors.transparent,
                borderColor: colors_1.colors.transparent,
            },
            horizontalPadding: true,
        },
        [ButtonTypes_1.ButtonAction.SENARY]: {
            backgroundColor: colors_1.colors.transparent,
            color: colors_1.colors.primary[500],
            borderColor: colors_1.colors.transparent,
            inverted: {
                backgroundColor: colors_1.colors.transparent,
                color: colors_1.colors.link,
                borderColor: colors_1.colors.transparent,
            },
            fontFamily: 'Roboto-Regular',
            border: 'none',
            disabled: {
                color: colors_1.colors.primary[200],
                backgroundColor: colors_1.colors.transparent,
                borderColor: colors_1.colors.transparent,
            },
            horizontalPadding: false,
        },
    },
    size: {
        [ButtonTypes_1.ButtonSize.XLARGE]: {
            height: '56px',
            borderRadius: '28px',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.7px',
            paddingVertical: '15px',
            paddingHorizontal: '29.5px',
        },
        [ButtonTypes_1.ButtonSize.DEFAULT]: {
            height: '46px',
            borderRadius: '23px',
            fontSize: '15px',
            lineHeight: '20px',
            letterSpacing: '0.7px',
            paddingVertical: '12px',
            paddingHorizontal: '25.5px',
        },
        [ButtonTypes_1.ButtonSize.MEDIUM]: {
            height: '40px',
            borderRadius: '20px',
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0.7px',
            paddingVertical: '10px',
            paddingHorizontal: '21.5px',
        },
        [ButtonTypes_1.ButtonSize.SMALL]: {
            height: '36px',
            borderRadius: '18px',
            fontSize: '13px',
            lineHeight: '19px',
            letterSpacing: '0.7px',
            paddingVertical: '8px',
            paddingHorizontal: '20px',
        },
        [ButtonTypes_1.ButtonSize.XSMALL]: {
            height: '29px',
            borderRadius: '14.5px',
            fontSize: '12px',
            lineHeight: '19px',
            letterSpacing: '0.7px',
            paddingVertical: '5px',
            paddingHorizontal: '14px',
        },
    },
};
